export default {"src":"/_next/static/media/Paraf.182d9f70.svg","height":20,"width":32};